// @flow
import styled from 'styled-components'
import ReactTable from 'react-table'
import 'react-table/react-table.css'

import colors from '../../styles/colors'
import sort from '../../images/sortIcon.svg'
import sortAsc from '../../images/sortAscIcon.svg'
import sortDesc from '../../images/sortDescIcon.svg'

const Table = styled(ReactTable)`
  max-width: 100%;
  border: none !important;

  .rt-noData {
    ${(props) => (props.innerTable ? `margin-top: 75px` : `margin-top: 15%`)};
    ${(props) => props.postModal && `margin-top:3%`};
    color: ${colors.light_black} !important;
  }

  .rt-table {
    overflow: hidden !important;
    font-size: 14px;
    color: ${colors.black};

    .rt-thead {
      ${(props) =>
        props.noBorderBottom
          ? ` border-bottom:none`
          : `   border-bottom: 1px solid black;`};
      &.-header {
        box-shadow: none;
      }

      .rt-tr {
        .rt-th {
          line-height: 52px;
          font-weight: 600;
          text-align: left;
          padding: 0 0 0 6px;
          ${(props) =>
            props.postModal
              ? ` :first-child {
            padding-left: 10px;
          }`
              : ``};

          &.-cursor-pointer {
            &:hover {
              background: url(${sort}) no-repeat 80% center;
            }

            &.-sort-asc {
              box-shadow: none;
              background: url(${sortAsc}) no-repeat 80% center;
            }

            &.-sort-desc {
              box-shadow: none;
              background: url(${sortDesc}) no-repeat 80% center;
            }
          }
        }
      }
    }

    .rt-tbody {
      line-height: 49px;

      .rt-tr-group {
        ${(props) =>
          props.borderTable
            ? ` border: 2px solid ${colors.alabaster};
                border-radius: 5px;
                margin: 5px;
                :last-child {
                border-bottom: 2px solid ${colors.alabaster};
                }`
            : ` border-bottom: 1px solid ${colors.alabaster}`};
        .rt-tr {
          &:hover {
            background-color: #eaeaea !important;
          }
          &.fade {
            opacity: 0.8;
          }

          .rt-td {
            border-right: none;
          }
        }
      }
    }
  }
`

export default Table
